/**
 * Deployed environment.
 */
export enum DeployedEnvironment {
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}

export function getDeployedEnvironment(): DeployedEnvironment {
  switch (process.env.NEXT_PUBLIC_DEPLOY_ENV) {
    case DeployedEnvironment.Development:
    case DeployedEnvironment.Staging:
    case DeployedEnvironment.Production:
      return process.env.NEXT_PUBLIC_DEPLOY_ENV as DeployedEnvironment;

    default:
      return DeployedEnvironment.Development;
  }
}

export const IS_TEST_ENV = process.env.NODE_ENV === 'test';

export const IS_DEVELOPMENT_ENV =
  getDeployedEnvironment() === DeployedEnvironment.Development;

export const IS_STAGING_ENV =
  getDeployedEnvironment() === DeployedEnvironment.Staging;

export const IS_PRODUCTION_ENV =
  getDeployedEnvironment() === DeployedEnvironment.Production;
